import { render, staticRenderFns } from "./layoutFooter.vue?vue&type=template&id=ff2f396c&"
import script from "./layoutFooter.vue?vue&type=script&lang=js&"
export * from "./layoutFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff2f396c')) {
      api.createRecord('ff2f396c', component.options)
    } else {
      api.reload('ff2f396c', component.options)
    }
    module.hot.accept("./layoutFooter.vue?vue&type=template&id=ff2f396c&", function () {
      api.rerender('ff2f396c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/shared/components/layout/layoutFooter.vue"
export default component.exports